import BaseModal from "../common/HPBaseModal";
import { ModalProps } from "../../_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";
import { WhiteArchiveIcon } from "@/assets/images";

interface ArchiveDashboardModalProps extends ModalProps {
  action: () => void;
  dashboardName: string;
}

const ArchiveDashboardModal: React.FC<ArchiveDashboardModalProps> = ({
  action,
  dashboardName,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <BaseModal
      title="Archive dashboard?"
      message={
        <span>
          Are you sure you want to archive <strong>{dashboardName}</strong> ?
        </span>
      }
      confirmButtonText="Archive"
      cancelButtonText="Cancel"
      confirmButtonIcon={<WhiteArchiveIcon />}
      onConfirm={action}
      onCancel={closeTopModal}
    />
  );
};

export default ArchiveDashboardModal;
